import type { FraudContext } from '@src/quince-site-common/src/services/payment-service/payment-service.types'

import { buildFraudContext } from './forter-token'

/**
 * Returns the authorize payload enriched with Forter fraud signals (`fraudContext`) when the Forter
 * kill-switch (`isEnabled`) is on and the caller hasn't already supplied them. UPG's fraud gate is
 * gateway-agnostic and reads `fraudContext.deviceToken`, so attaching it here once — inside
 * `authorizePayment` — means every payment method (card, saved card, PayPal, Apple/Google Pay + express,
 * Klarna, Afterpay, …) gets Forter coverage without wiring it up individually.
 *
 * Fail-safe + fail-open: returns the payload unchanged when the gate is off (never even reads the token) or
 * when no Forter device token is available yet (the BE fails open on a missing token). Generic so it
 * composes with any fraud-context-bearing request, not just the authorize payload.
 */
export const withFraudContext = <T extends { fraudContext?: FraudContext }>(
  payload: T,
  isEnabled: boolean,
): T => {
  if (!isEnabled) return payload
  if (payload.fraudContext) return payload
  const fraudContext = buildFraudContext()
  return fraudContext ? { ...payload, fraudContext } : payload
}
